import { render, staticRenderFns } from "./SettingsTeamMembers.vue?vue&type=template&id=f3ca9e12&scoped=true"
import script from "./SettingsTeamMembers.vue?vue&type=script&lang=js"
export * from "./SettingsTeamMembers.vue?vue&type=script&lang=js"
import style0 from "./SettingsTeamMembers.vue?vue&type=style&index=0&id=f3ca9e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ca9e12",
  null
  
)

export default component.exports